<template>
  <div class="eve-fair-area">
    <fair-item
      v-for="item in list"
      :key="item.exhibitionId"
      :item="item" />
  </div>
</template>

<script lang="ts" setup>
  import { defineAsyncComponent, defineProps } from 'vue'

  const FairItem = defineAsyncComponent(() => import('./FairItem.vue'))

  defineProps<{
    list: Array<any>
  }>()
</script>

<style lang="less" scoped>
  .eve-fair-area {
    .exh_item {
      width: 362px;
      display: flex;
      padding: 14px 0 14px 14px;
      margin-bottom: 8px;
      background: #fff;
      border-radius: 6px;

      .left_item {
        width: 88px;
        height: 88px;
        margin-right: 14px;
        // border: 1px solid #ddd;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        img {
          width: 120px;
          height: auto;
        }
      }

      .right_item {
        width: 236px;

        .En {
          display: flex;
          margin-bottom: 8px;

          .En_name {
            font-size: 18px;
            font-weight: bold;
            color: @app-color;
            flex: 1;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;

            a {
              color: @app-color;
            }
          }

          .hot {
            display: flex;
            align-items: center;

            img {
              height: 15px;
              width: auto;
              margin-right: 5px;
            }

            .hot_num {
              font-size: 16px;
              color: #333;
            }
          }
        }

        .name_remind {
          font-size: 16px;
          color: #333;
          letter-spacing: 1px;
          margin-bottom: 5px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }

        .time_remind {
          font-size: 16px;
          color: #999;
          margin-bottom: 5px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }

        .btn_remind {
          display: flex;
          align-items: center;
          margin-top: 10px;

          .follow {
            font-size: 12px;
            color: #333;
            padding: 5px 8px;
            background: #fff;
            border-radius: 4px;
            border: 1px solid #cdcfd6;
            margin-right: 8px;
          }

          .distance {
            font-size: 16px;
            color: #333;
            margin-left: auto;

            span {
              color: #ff8600;
              font-size: 16px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
</style>
